import { useParams } from 'react-router-dom';
import { Layout } from '@/components/ui/Layout';
import { RespondentManager } from '@/components/surveys/RespondentManager';

export function SurveyRespondents() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Layout>Invalid survey ID</Layout>;
  }

  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <RespondentManager surveyId={id} />
      </div>
    </Layout>
  );
}